/* @ngInject */
const ownerFields = (
  ownerLabels,
  types,
  icons
) => {
  const self = {}

  self.id = {
    ref: 'id',
    label: ownerLabels.fields.id.text,
    icon: icons.id,
    output: false,
  }

  self.selectId = {
    ref: 'selectId',
    label: ownerLabels.fields.selectId.text,
    icon: icons.selectId,
    type: types.select,
    choice: 'Choix du propriétaire',
    options: 'owner.id as owner.society for owner',
    order: 'society.toString()',
    output: false,
  }

  self.society = {
    ref: 'society',
    label: ownerLabels.fields.society.text,
    icon: icons.owner.society,
    type: types.text(),
    required: true,
    unique: true,
    nature: 'owner',
    messages: ownerLabels.fields.society.messages,
    output: {
      sortable: true,
      table: { prefill: true, },
      details: true,
      excel: { prefill: true, },
    },
  }

  self.address = {
    ref: 'address',
    label: ownerLabels.fields.address.text,
    icon: icons.owner.address,
    type: types.text(),
    output: {
      sortable: true,
      table: { prefill: true, },
      details: true,
      excel: { prefill: true, },
    },
  }

  self.cp = {
    ref: 'cp',
    label: ownerLabels.fields.cp.text,
    icon: icons.owner.cp,
    type: types.cp,
    output: {
      sortable: true,
      table: { prefill: true, },
      details: true,
      excel: { prefill: true, },
    },
  }

  self.city = {
    ref: 'city',
    label: ownerLabels.fields.city.text,
    icon: icons.owner.city,
    type: types.text(),
    output: {
      sortable: true,
      table: { prefill: true, },
      details: true,
      excel: { prefill: true, },
    },
  }

  self.country = {
    ref: 'country',
    label: ownerLabels.fields.country.text,
    icon: icons.owner.country,
    type: types.text(),
    output: {
      sortable: true,
      table: { prefill: true, },
      details: true,
      excel: { prefill: true, },
    },
  }

  self.contactCount = {
    ref: 'contactCount',
    label: ownerLabels.fields.contactCount.text,
    icon: icons.owner.contactCount,
    output: {
      sortable: true,
      table: { prefill: true, },
      details: false,
      excel: { prefill: false, },
    },
  }

  return self
}
export default ownerFields



// WEBPACK FOOTER //
// ./public/javascript/sygem/entities/owners/owner/resources/fields.resource.js